export default function VisibilityOffIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="visibility-off-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="m644-428-58-58q11-53-27.5-90.5T466-606l-58-58q17-8 35-12t37-4q75 0 127.5 52.5T660-500q0 19-4 37t-12 35Zm128 126-58-56q38-29 68-64.5t50-77.5q-50-101-144.5-160.5T480-720q-29 0-56.5 4T368-704l-62-62q42-17 85.5-25.5T480-800q137 0 250.5 72T904-534q4 8 6 16.5t2 17.5q0 9-1.5 17.5T905-466q-22 49-56 90.5T772-302ZM480-200q-134 0-245-72.5T60-463q-5-8-7.5-17.5T50-500q0-10 2-19t7-18q20-40 46.5-76.5T166-680l-83-84q-11-12-10.5-28.5T84-820q11-11 28-11t28 11l680 680q11 11 11.5 27.5T820-84q-11 11-28 11t-28-11L624-222q-35 11-71 16.5t-73 5.5ZM222-624q-29 26-53 57t-41 67q50 101 144.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
      />
    </svg>
  );
}
